import {createSelector} from 'reselect';

import {ReportResultActions, ReportResultActionTypes,} from '../actions/reportResultActions';
import {ApiStatus,} from '../../models';
import {IState} from './index';

type IResult = {
  report_uid: string;
  [key: string]: any;
}

type ExecutionStatus = {
  [key: string]: ApiStatus; /* reportId / reportUid */
};

export const initialReportResultState: ReportResultState = {
  results: null,
  executionStatus: null,
}

export interface ReportResultState {
  results: IResult[] | null;
  executionStatus: ExecutionStatus | null;
}

export default function reportResultReducer(
  state: ReportResultState = initialReportResultState,
  action: ReportResultActions
): ReportResultState {
  switch (action.type) {
    case ReportResultActionTypes.EXECUTE_REPORT:
    case ReportResultActionTypes.RE_RUN_REPORT:
      return {
        ...state,
        executionStatus: {
          ...state.executionStatus || {},
          [action.payload.uid]: ApiStatus.LOADING,
        }
      }
    case ReportResultActionTypes.EXECUTED_REPORT:
    case ReportResultActionTypes.RE_RUN_REPORT_SUCCESS:
      return {
        ...state,
        executionStatus: {
          ...state.executionStatus || {},
          [action.payload]: ApiStatus.LOADED,
        }
      }
    case ReportResultActionTypes.EXECUTING_REPORT_FAILED:
      case ReportResultActionTypes.RE_RUN_REPORT_FAILED:
      return {
        ...state,
        executionStatus: {
          ...state.executionStatus || {},
          [action.payload]: ApiStatus.FAILED,
        }
  }
    case ReportResultActionTypes.LOADED_REPORT_RESULT:
      return handleLoadedReportResult(state, action);
    case ReportResultActionTypes.UNSET_REPORT_EXECUTIONS:
      return {
        results: null,
        executionStatus: null,
      }
    default:
      return state;
  }
}

// Functions

function handleLoadedReportResult(state: ReportResultState, action: any): ReportResultState {
  const {uid, result} = action.payload;

  return {
    ...state,
    results: [
      // last execution, first result
      {
        report_uid: uid,
        ...result,
      },
      ...state.results || [],
    ]
  }
}

// Selectors

export const getReportLastResultSelector = (uid: string) => createSelector(
  (state: IState) => state.reportResult.results,
  (results: IResult[] | null): any | null => {
    return results?.find((result: IResult) => result?.report_uid === uid) || null;
  },
);

export const getReportExecutionStatusSelector = (uid: string) => createSelector(
  (state: IState) => state.reportResult.executionStatus,
  (executionStatus: ExecutionStatus | null): ApiStatus | null => {
    return executionStatus?.[uid] || null;
  },
);
